import React from 'react';
import { PropTypes } from 'prop-types';
import Skeleton from 'Common/Components/Skeleton';
import { Wrapper } from './styled';
import EditButton from 'Screens/Credentials/components/ActionBar/components/EditButton';
import DeleteButton from 'Screens/Credentials/components/ActionBar/components/DeleteButton';

const ActionsCell = ({ rowInfo, showSkeleton }) => {
  if (showSkeleton) return <Skeleton />;
  return (
    <Wrapper>
      <EditButton rowInfo={ rowInfo } />
      <DeleteButton rowInfo={ rowInfo } />
    </Wrapper>
  );
};

ActionsCell.propTypes = {
  rowInfo: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  showSkeleton: PropTypes.bool
};

ActionsCell.defaultProps = {
  field: '',
  showSkeleton: false
};

export default ActionsCell;
